import PropTypes from 'prop-types';
import React from 'react';

class Card extends React.Component {
  static defaultProps = {
    fullWidth: false,
    style: {},
  };

  static displayName = 'Card';

  static propTypes = {
    children: PropTypes.element.isRequired,
    footer: PropTypes.any,
    fullWidth: PropTypes.bool,
    header: PropTypes.any,
    width: PropTypes.number,
    style: PropTypes.object,
  };

  render() {
    let header = this.props.header;

    if (typeof header === 'string') {
      header = <h3>{header}</h3>;
    }

    return <div className={'card' + (this.props.fullWidth ? ' full-width-card' : '')} style={this.props.style}>
      {header ? <div className='card-header'>{header}</div> : null}
      <div className='card-body'>{this.props.children}</div>
      {this.props.footer ? <div className='card-footer'>{this.props.footer}</div> : null}
    </div>;
  }
}

export default Card;
